import moment from 'moment';

export class SummaryPeak {
    stateId: number;
    stateName: string;
    countyId: number;
    countyName: string;
    stateAbbreviation: string;
    currentOutages: number;
    startTime: moment.Moment;
    peakTime: moment.Moment;
    peakOutages: number;
    percentOutages: number;
    percentRestored: number;
    currentTime: moment.Moment;
    coveredCustomers: number;
    utilityId: number;
    utilityName: string;
    subUtilityId: number;
    subUtilityName: string;
    last24HourRestoreProgress: number;

    constructor(input?: SummaryPeak) {
        this.stateId = input.stateId;
        this.stateName = input.stateName;
        this.countyId = input.countyId;
        this.countyName = input.countyName;
        this.stateAbbreviation = input.stateAbbreviation;
        this.currentOutages = input.currentOutages;
        this.startTime = moment(input.startTime);
        this.peakTime = moment(input.peakTime);
        this.peakOutages = input.peakOutages;
        this.percentOutages = input.percentOutages;
        this.percentRestored = input.percentRestored;
        this.currentTime = moment(input.currentTime);
        this.coveredCustomers = input.coveredCustomers;
        this.utilityId = input.utilityId;
        this.utilityName = input.utilityName;
        this.subUtilityId = input.subUtilityId;
        this.subUtilityName = input.subUtilityName;
        this.last24HourRestoreProgress = input.last24HourRestoreProgress;
    }
}
